var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-component__label"},[_vm._t("default"),_vm._v(" "),(_vm.optional)?_c('span',{staticClass:"text-sm font-normal italic text-copy-muted"},[_vm._v("\n\t\t("+_vm._s(_vm.$t('optional'))+")\n\t")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }